var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slider",staticClass:"slider-pro",class:{ 'no-swipe': _vm.$slots.default && _vm.$slots.default.length === 1 }},[_c('div',{staticClass:"sp-slides"},[_vm._t("default")],2),_vm._t("thumbnails")],2)}
var staticRenderFns = []

export { render, staticRenderFns }